<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="orderInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="商品简称" class='tiny'>
						<el-input style="width:200px;" v-model="orderInfo.pdtName" placeholder="请输入商品简称">
						</el-input>
					</el-form-item>
					<el-form-item label="商品编码" class='tiny'>
						<el-input style="width:200px;" v-model="orderInfo.pdtCode" placeholder="请输入商品编码">
						</el-input>
					</el-form-item>
					<el-form-item label="状态" class='tiny'>
						<el-select v-model="orderInfo.status" class="big" placeholder="请选择状态" clear>
							<el-option :key="0" label="禁用" :value="0">禁用</el-option>
							<el-option :key="1" label="正常" :value="1">正常</el-option>
						
							
						</el-select>
					</el-form-item>
					<el-form-item label="单位" class='tiny'>
						<el-select clearable filterable v-model="orderInfo.unitName" placeholder="请选择单位"
							>
							<el-option v-for="item in unitList" :key="item.id" :label="item.name" :value="item.name">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button  @click="empty">清空</el-button>
							<el-button type="primary" @click="downloadFile"> 导出 </el-button>
						</template>
					</el-form-item>
					<el-button type="primary" @click="addCarousel">新增</el-button>
				</el-form>

			</header>

		</div>
		<!-- 列表展示 -->
		<el-table :data="expressList" stripe style="width: 100%" >
			<el-table-column type="expand" width="50">
				<template slot-scope="props">
					<el-form label-position="left" inline class="demo-table-expand" label-width="120px">
						<el-form-item label="长(mm)">
							<span>{{props.row.length}}</span>
						</el-form-item>
						<el-form-item label="宽(mm)">
							<span>{{props.row.width}}</span>
						</el-form-item>
						<el-form-item label="高(mm)">
							<span>{{props.row.high}}</span>
						</el-form-item>
						<el-form-item label="单台体积(m³)">
							<span>{{props.row.volumeSingle}}</span>
						</el-form-item>						
						<el-form-item label="单台重量(kg)">
							<span>{{props.row.weightSingle}}</span>
						</el-form-item>
						<el-form-item label="主图">
							<!-- <span @click="lookzj(props.row.mainIcon)">查看</span> -->
							<el-button type="text" @click="lookzj(props.row.mainIcon)">查看</el-button>
						</el-form-item>
						<el-form-item label="商品介绍">
							<!-- <span @click="lookxq(props.row.introduce)">查看</span> -->
							<el-button type="text" @click="lookxq(props.row.introduce)">查看</el-button>
						</el-form-item>
					</el-form>
				</template>
			</el-table-column>
			<el-table-column type="index" align="center" width="50" label="#"></el-table-column>
		<!-- 	<el-table-column prop="id" label="编号" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column> -->
			
			<el-table-column prop="pdtName" label="商品简称" align="center" min-width="150" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="pdtCode" label="商品编码" align="center" width="150" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="unitName" label="单位" align="center" width="50" :show-overflow-tooltip="true">
			</el-table-column>

			<el-table-column prop="volume" label="箱体积(m³)" align="center" width="100" :show-overflow-tooltip="true"
			:formatter="changeNull"></el-table-column>
			<el-table-column prop="weight" label="箱重量(kg)" align="center" width="100" :show-overflow-tooltip="true"
			:formatter="changeNull"></el-table-column>
			<el-table-column prop="boxGauge" label="箱规" align="center" width="80" :show-overflow-tooltip="true" 
			:formatter="changeNull"></el-table-column>
			<el-table-column prop="status" label="状态" align="center" :show-overflow-tooltip="true" width="80">
				<template slot-scope="scope">
					<span v-if="scope.row.status==0">禁用</span>
					<span v-if="scope.row.status==1">正常</span>
				</template>
			</el-table-column>
			<el-table-column prop="createBy" label="创建人" align="center" width="120" :show-overflow-tooltip="true">
			</el-table-column>
			
			<el-table-column prop="createTime" label="创建时间" align="center" width="160" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="updateTime" label="更新时间" align="center" width="160" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="" label="操作" align="center" :show-overflow-tooltip="true" fixed="right" width="150">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="editialogVisible(scope.row.id)">编辑</el-button>
					<el-button size="small" type="text" @click="toDelete(scope.row.id)">删除</el-button>
					　　　　
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination style="margin: 20px auto;width:100%;" background :current-page="sliderlist.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="sliderlist.total"
			@size-change="handleSizeChange">
		</el-pagination>
		<!-- 新增、编辑 -->
		<el-dialog :visible.sync="dialogVisibleSwiper" :title="title" @close="addDialogClose"
			:close-on-click-modal="false" width="1000px">
			<div style="text-align: center; padding-right:50px">
				<el-form v-model="storeGoodsInfo">
					<div style="display: flex;align-items: center;">
						<el-form-item label="商品简称" label-width="120px">
							<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.pdtName"
								auto-complete="off" placeholder="请输入商品简称" />
						</el-form-item>
						<el-form-item label="商品编码" label-width="120px">
							<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.pdtCode"
								auto-complete="off" placeholder="请输入商品编码" />
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;">
						<el-form-item label="单位" label-width="120px">
							<el-select clearable filterable v-model="storeGoodsInfo.unitName" placeholder="请选择单位"
								 style="width: 300px;">
								<el-option v-for="item in unitList" :key="item.id" :label="item.name" :value="item.name">
								</el-option>
							</el-select>
						</el-form-item>							
					</div>
					<div style="display: flex;align-items: center;">
						<el-form-item label="长" label-width="120px">
							<el-input type="number" style="width: 220px;" v-model="storeGoodsInfo.length"
								auto-complete="off" placeholder="请输入长度(mm)" @blur="calculateVolume">
								<template slot="append">mm</template>
							</el-input>
						</el-form-item>
						<el-form-item label="宽" label-width="50px">
							<el-input type="number" style="width: 220px;" v-model="storeGoodsInfo.width"
								auto-complete="off" placeholder="请输入宽度(mm)" @blur="calculateVolume">
								<template slot="append">mm</template>
							</el-input>
						</el-form-item>
						<el-form-item label="高" label-width="50px">
							<el-input type="number" style="width: 220px;" v-model="storeGoodsInfo.high"
								auto-complete="off" placeholder="请输入高度(mm)" @blur="calculateVolume">
								<template slot="append">mm</template>
							</el-input>
						</el-form-item>
					</div>
					<div>
						<el-form-item label="体积" label-width="120px">
							<el-input type="number" style="width: 300px;" v-model="volume" disabled
								auto-complete="off" placeholder="请输入体积(m³)" >
								<template slot="append">m³</template>
							</el-input>
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;">
						<el-form-item label="重量" label-width="120px" >
						<el-input type="number" style="width: 300px;" v-model="storeGoodsInfo.weight"
							auto-complete="off" placeholder="请输入商品重量(kg)" >
							<template slot="append">kg</template>
						</el-input>
						</el-form-item>
						<el-form-item label="箱规" label-width="120px" >
						<el-input @input="changeValue" type="number" style="width: 300px;" v-model="storeGoodsInfo.boxGauge"
							auto-complete="off"  placeholder="请输入箱规(必须大于0的整数)" @blur="calculateVolumeOne"/>
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;">
						<el-form-item label="单台体积" label-width="120px">
							<el-input type="number" style="width: 300px;" v-model="volumeSinolet" 
								auto-complete="off" placeholder="请输入单台体积(m³)" >
								<template slot="append">m³</template>
							</el-input>
						</el-form-item>
						<el-form-item label="单台重量" label-width="120px">
							<el-input type="number" style="width: 300px;" v-model="storeGoodsInfo.weightSingle" 
								auto-complete="off" placeholder="请输入单台重量(kg)" >
								<template slot="append">kg</template>
							</el-input>
						</el-form-item>
					</div>
					
					<div>
						
						<el-form-item label="主图" label-width="120px" style="">
							<el-upload :action="httpUrl" list-type="picture-card" :on-preview="handlePictureCardPreview"
								:on-remove="handleRemove" :file-list="fileList" :show-file-list="true" 
								:on-success="onSuccess">
								<i class="el-icon-plus"></i>
							</el-upload>
						</el-form-item>
						<el-form-item label="状态" label-width="120px" style="display: flex;align-items: center;">
							<el-switch v-model="storeGoodsInfo.status" :active-value="true" :inactive-value="false">
							</el-switch>
						</el-form-item>
					</div>
					
					
					
					<div style="height: 600px;">
						<div style="text-align: start;margin: 10px;">商品介绍</div>
						<el-form-item>
							<div id="lpc-quill" class="quill">
								<el-upload class="upload-demo" v-show="false" ref="upload" :action="httpUrl"
									:before-upload="beforeAvatarUpload" :on-success="upScuccess"
									:on-error="uploadError" />
								<quill-editor v-model="storeGoodsInfo.introduce" ref="myQuillEditor" class="editer"
									style="height: 400px;width: 800px;" :options="editorOption"
									@ready="onEditorReady($event)">
								</quill-editor>
							</div>
						</el-form-item>
					</div>
					
					<el-button type="primary" v-if="title=='添加商品'" @click="submit">新增</el-button>
					<el-button type="primary" v-else @click="submitClick">提交</el-button>

				</el-form>
			</div>
		</el-dialog>
		
		<el-dialog :visible.sync="dialogVisibleImg" style="float:rigin;height: 100%;" :closeOnClickModal="false">
			<el-carousel indicator-position="outside" style="height: 600px;">
				<el-carousel-item v-for="(item,index) in dialogImageUrl" :key="index" style="height: 500px;">
					<img :src="item" style="width: 100%; height: 100%;" />
				</el-carousel-item>
			</el-carousel>
			<el-button type="primary" @click="dialogVisibleImg = false">关 闭</el-button>
		</el-dialog>
		<el-dialog  :visible.sync="dialogIntroVisible" title="详情">
			<div v-html="storeIntro" style="height: 600px;overflow-y: scroll;"></div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		uploadFile
	} from "@/api/axios.js";
	var urls = uploadFile();
	import {
		quillEditor
	} from "vue-quill-editor"; //调用编辑器
	import "quill/dist/quill.core.css";
	import "quill/dist/quill.snow.css";
	import "quill/dist/quill.bubble.css";
	export default {
		components: {
			//使用编辑器
			quillEditor
		},
		data() {
			return {
					httpUrl: urls+'?type=2023',
				page: {
					pageNum: 1,
					pageSize: 10,
				},
				unitList:[],
				storeIntro:'',
				dialogIntroVisible:false,
				expressList: [],
				dialogImageUrl:[],
				dialogVisibleImg:false,
				title:'',
				orderInfo: {},
				sliderlist:{},
				goodsImages:[],
				storeGoodsInfo: {
					boxGauge:1,
				},
				volume:'',
				volumeSinolet: '',
				fileList:[],
				dialogVisibleSwiper: false,
				dialogVisibleSwipers: false,
				editorOption: {
					// 富文本编辑器配置
					placeholder: "请输入内容",
					modules: {
						toolbar: {
							container: [
								["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
								[{
										header: 1,
									},
									{
										header: 2,
									},
								], // 标题，键值对的形式；1、2表示字体大小
								[{
										list: "ordered",
									},
									{
										list: "bullet",
									},
								], // 列表
								[{
										script: "sub",
									},
									{
										script: "super",
									},
								], // 上下标
								[{
										indent: "-1",
									},
									{
										indent: "+1",
									},
								], // 缩进
								[{
									direction: "rtl",
								}, ], // 文本方向
								[{
									size: ["small", false, "large", "huge"],
								}, ], // 字体大小
								[{
										color: [],
									},
									{
										background: [],
									},
								], // 字体颜色，字体背景颜色
								[{
									align: [],
								}, ], // 对齐方式
								["clean"], // 清除字体样式
								["image"], // 上传图片、上传视频
							],
							handlers: {
								image: function(value) {
									// console.log(value)
									if (value) {
										document
											.querySelector("#lpc-quill .upload-demo input")
											.click();
									} else {
										this.quill.format("image", false);
									}
								},
							},
				
						},
					},
					theme: "snow",
				}

			}
		},
		methods: {
			//导出
			downloadFile() {
				let data = {
					...this.orderInfo
				};
				// console.log(data);
				this.$api.goodsListExportExcel(data).then((res) => {
					// console.log(res.data);
					this.showloadFile(res.data);
				});
			},
			showloadFile(res) {
				if (!res) {
					return;
				}
				const link = document.createElement("a");
				let blob = new Blob([res], {
					type: "application/vnd.ms-excel",
				});
				link.style.display = "none";
				link.href = URL.createObjectURL(blob);
				link.setAttribute("download", "商品管理" + ".xls");
				document.body.appendChild(link);
				link.click();
				URL.revokeObjectURL(link.href); // 释放URL 对象
				document.body.removeChild(link);
			},
			changeNull(row, column, cellValue) { //处理数据为null的情况
				if (cellValue) {
					return cellValue;
				} else {
					return "未设置";
				}
			},
			calculateVolume(){ //计算体积
				// console.log(111)
				if(this.storeGoodsInfo.length && this.storeGoodsInfo.width && this.storeGoodsInfo.high){
					// console.log(222)
					let L = this.storeGoodsInfo.length / 1000;
					let W = this.storeGoodsInfo.width / 1000;
					let H = this.storeGoodsInfo.high / 1000;
					// console.log('volume--', L*W*H)
					this.volume = L*W*H;
					this.volumeSinolet = this.volume / this.storeGoodsInfo.boxGauge
				}
				
			},
			calculateVolumeOne(){
				this.volumeSinolet = this.volume / this.storeGoodsInfo.boxGauge
			},
			lookxq(storeIntro){
				this.dialogIntroVisible=true
				this.storeIntro=storeIntro
			},
			// 上传图片前，筛选
			beforeAvatarUpload(file) {
				// console.log(file)1048576
				const isLt2M = file.size / 1024 / 1024 < 8;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 8MB!');
					return false;
				}
				var imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				}
				return isLt2M, imgStr;
			},
			upScuccess(res, file) {
				const quill = this.$refs.myQuillEditor.quill;
				if (res.state == "success" && res.message !== null) {
					const length = quill.getSelection().index; // 获取光标所在位置
					quill.insertEmbed(length, "image", res.message); // 插入图片
					quill.setSelection(length + 1); // 调整光标位置到最后
				} else {
					this.$message.error("图片上传失败");
				}
			},
			changeValue(value) {
			     this.storeGoodsInfo.boxGauge = /^[0-9]*$/.test(parseInt(value)) ? String(parseInt(value)).replace(".", "") : ""
			 },

			uploadError() {
				this.$message.error("图片上传失败");
			},
			onEditorReady(editor) {
				// 准备编辑器
				// console.log(editor);
			},
			onSuccess(response, file, fileList) {
				// console.log(res)
				this.goodsImages.push(response.message);
				// console.log("asda",response,this.goodsImages)
			},
			handleRemove(file, fileList) {
				if (file.response) {
					this.goodsImages.remove(file.response.message);
				}
				this.goodsImages.remove(file.url);
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url.split(',');
				this.dialogVisibleImg = true;
			},
			search() { //查询
				this.page.pageNum = 1;
				this.findPmsUnit()

			},
			empty() { //清空
				this.orderInfo = {}

			},
			addDialogClose() {
				// console.log('aaa')

				this.storeGoodsInfo = {
					status:true,
					boxGauge:1
				}
			},
			findPmsUnit() {
				let data = {
					 pageNum: this.page.pageNum,
					 pageSize: this.page.pageSize,
					 ...this.orderInfo
					// name:this.orderInfo.name
				}
				this.$api.carsgoodslist(this.$encrypt(data)).then((res) => {
					res.data=JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
						this.expressList = res.data.list
						this.sliderlist = res.data
					}
				})

			},
			lookzj(img){
				this.dialogImageUrl=img.split(',')
				// console.log(this.dialogImageUrl);
				this.dialogVisibleImg=true
			},
			// 新增
			addCarousel() {
				this.goodsImages=[]
				this.fileList=[]
				this.storeGoodsInfo = {
					status:true,
					boxGauge:1
				}
				this.volume = '';
				this.volumeSinolet ='';
				this.dialogVisibleSwiper = true
				this.title='添加商品'
			},

			// 提交
			submit() {
				let data = {
					...this.storeGoodsInfo,
					volume : this.volume,
					volumeSingle: this.volumeSinolet,
					mainIcon:this.goodsImages.join(',')
				}
				// console.log('添加---', data)
				this.$api.addcarsgoods(this.$encrypt(data)).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.findPmsUnit()
						this.dialogVisibleSwiper = false
						this.storeGoodsInfo = {
							boxGauge:1
						}
					} else {
						this.$message.error(res.message);
					}
				})

			},

			// 编辑
			editialogVisible(e) {
				this.title='编辑商品'
				this.goodsImages=''
				this.fileList=[]
				this.$api.findcarsgood(e).then((res) => {
					res.data=JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
						this.storeGoodsInfo = res.data
						let imagesArray = res.data.mainIcon.split(',')
						for (let i = 0; i < imagesArray.length; i++) {
							this.fileList.push({
								name: imagesArray[i],
								url:imagesArray[i]
							
							})
						}
						this.goodsImages=imagesArray
						// console.log(this.goodsImages.join(','));
						this.volume = res.data.volume;
						this.volumeSinolet = res.data.volumeSingle;
						this.dialogVisibleSwiper = true
				
					}
				})

			},
			// 编辑修改提交
			submitClick() {
				// console.log();
				let data = {
					...this.storeGoodsInfo,
					volume : this.volume,
					volumeSingle: this.volumeSinolet,
					mainIcon:this.goodsImages.join(',')
				
				}
				
				this.$api.upcarsgoods(this.$encrypt(data)).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisibleSwiper = false
						this.findPmsUnit();
						this.storeGoodsInfo = {
							boxGauge:1
						}
					} else {
						this.$message.error(res.message);
					}
				})

			},
			// 删除
			toDelete(e) {
				// console.log(e)
				var str = "此操作将删除该商品, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// console.log(e)
					this.$api.delcarsgood(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.findPmsUnit();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			pageChange(data) {
				this.page.pageNum = data
				this.findPmsUnit();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.findPmsUnit()
			},
		},




		created() {
			this.findPmsUnit()
			this.$api.findPmsUnit({}).then(res=>{
				// console.log(res.data.list);
				this.unitList=res.data.list
			})
		}
	}
</script>

<style>
	.demo-table-expand{
		margin-left: 30px;
	}
</style>
